module.exports = __webpack_public_path__ + "media/src/site/images/enter-6c96aa3e9fa9de59c24897b0fca76e95.svg";